import { ALIGNMENT } from 'prose-core'
import { useAlignButtonToggle } from 'common/Prose/Toolbar/hooks/useAlignButtonToggle'
import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const AlignLeftButton = observer(() => {
  const { active, handleClick } = useAlignButtonToggle(ALIGNMENT.Left)

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.AlignLeft} />}
      label="Left"
      ariaLabel="Align left"
      active={active}
      handleClick={handleClick}
    />
  )
})
